<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">REPORTES</h4>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="nav-wrapper position-relative end-0">
              <ul class="p-1 bg-transparent nav nav-pills nav-fill">
                <li class="nav-item">
                  <a
                    class="mb-3 btn btn-sm w-100"
                    style="cursor: pointer"
                    :class="{ 'btn-info': seleccionartap2 == true }"
                    @click="seleccionartap(2)"
                    >DESCARGAR REPORTE</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="mb-3 btn btn-sm w-100"
                    style="cursor: pointer"
                    :class="{ 'btn-info': seleccionartap3 == true }"
                    @click="seleccionartap(3)"
                    >GRAFICOS</a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <!-- ------------------------------------------------------------------------------- -->
                <div v-show="seleccionartap2">
                  <div class="row">
                    <div class="col-md-3">
                      <h6><strong>FECHA INICIAL</strong></h6>
                      <div class="form-group">
                        <input
                          class="form-control"
                          v-model="fechainicial"
                          placeholder="Buscar por nombre"
                          type="date"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <h6><strong>FECHA FINAL</strong></h6>
                      <div class="form-group">
                        <input
                          class="form-control"
                          v-model="fechafinal"
                          placeholder="Buscar por nombre"
                          type="date"
                        />
                      </div>
                    </div>
                  </div>
                    <div class="text-center">
                      <a
                        @click="descargar_reporte()"
                        type="button"
                        class="btn btn-info"
                      >
                        Generar reporte
                      </a>
                    </div>
                </div>
                <!-- ------------------------------------------------------------------------------- -->
                <div v-show="seleccionartap3">
                  <div class="row">
                    <div class="col-md-3">
                      <h6><strong>FECHA INICIAL</strong></h6>
                      <div class="form-group">
                        <input
                          class="form-control"
                          v-model="fechainicial"
                          placeholder="Buscar por nombre"
                          type="date"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <h6><strong>FECHA FINAL</strong></h6>
                      <div class="form-group">
                        <input
                          class="form-control"
                          v-model="fechafinal"
                          placeholder="Buscar por nombre"
                          type="date"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <a
                      @click="vergraficosanio()"
                      type="button"
                      class="btn btn-info"
                    >
                      Ver
                    </a>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div id="graficomeses"></div>
                    </div>
                    <div class="col-md-6">
                      <div id="graficomeses1"></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div id="graficoservicio"></div>
                    </div>
                    <div class="col-md-6">
                      <div id="grafico"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import axios from "axios";
import * as XLSX from 'xlsx';
export default {
  name: "profile",
  data() {
    return {
      seleccionartap2: true,
      seleccionartap3: false,
      fechainicial: "",
      fechafinal: "",
      myChart: "",
      myChart1: "",
    };
  },
  components: {},
  created: function () {
  },
  mounted() {
    this.seleccionartap(2);
  },
  methods: {
    seleccionartap(opcion) {
      switch (opcion) {
        case 2:
          this.seleccionartap2 = true;
          this.seleccionartap3 = false;
          this.fechainicial = "";
          this.fechafinal = "";
          break;
        case 3:
          this.seleccionartap2 = false;
          this.seleccionartap3 = true;
          this.fechainicial = "";
          this.fechafinal = "";
          break;
        default:
      }
    },
  
    descargar_reporte() {
      if (
        this.fechainicial == "" ||
        this.fechainicial == undefined ||
        this.fechainicial == null ||
        this.fechafinal == "" ||
        this.fechafinal == undefined ||
        this.fechafinal == null
      ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Especificar un nombre o una cedula",
          "info"
        );
      } else {
        const peticion = {
          fechainicial: this.fechainicial,
          fechafinal: this.fechafinal,
        };
        axios
          .post("descargar_report", peticion)
          .then((respuesta) => {
            const datos = respuesta.data;
                  const worksheet = XLSX.utils.json_to_sheet(datos);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos Solicitudes');

  // Generar el archivo Excel
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  // Crear enlace de descarga
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'ReporteTurnos.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    vergraficosanio() {
      this.vergraficosanio1();
      this.vergraficos();
      this.vergraficosservicios();
      const peticion = {
        fechainicial: this.fechainicial,
        fechafinal: this.fechafinal,
        accion: "A",
      };
      axios.post("ver_graficos_servicios", peticion).then((response) => {
        var mes = [];
        var cantidad_consulta = [];
        let datos = response.data;
        for (const color of datos) {
          const sedeExistente = cantidad_consulta.find(
            (item) => item.name === color.mes
          );
          if (sedeExistente) {
            sedeExistente.data.push(color.cantidad);
          } else {
            var datosgraficos = {
              name: color.mes,
              data: [color.cantidad],
            };
            cantidad_consulta.push(datosgraficos);
          }
          mes.push(color.mes + "_" + color.anio);
        }

        const uniqueSet = new Set(mes);
        const uniqueArray = Array.from(uniqueSet);
        var options = {
          series: cantidad_consulta,
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: "13px",
                    fontWeight: 900,
                  },
                },
              },
            },
          },
          xaxis: {
            type: "Meses",
            categories: uniqueArray,
          },
          legend: {
            position: "right",
            offsetY: 40,
          },
          fill: {
            opacity: 1,
          },
        };

        var chart = new ApexCharts(
          document.querySelector("#graficomeses"),
          options
        );
        chart.render();
      });
    },
    vergraficosanio1() {
      const peticion = {
        fechainicial: this.fechainicial,
        fechafinal: this.fechafinal,
        accion: "A",
      };
      axios.post("ver_graficos_servicios", peticion).then((response) => {
        var mes = [];
        var cantidad_consulta = [];
        let datos = response.data;
        for (const color of datos) {
          const sedeExistente = cantidad_consulta.find(
            (item) => item.name === color.nombre_sede
          );
          if (sedeExistente) {
            sedeExistente.data.push(color.cantidad);
          } else {
            var datosgraficos = {
              name: color.nombre_sede,
              data: [color.cantidad],
            };
            cantidad_consulta.push(datosgraficos);
          }
          mes.push(color.mes + "_" + color.anio);
        }

        const uniqueSet = new Set(mes);
        const uniqueArray = Array.from(uniqueSet);
        var options = {
          series: cantidad_consulta,
          chart: {
            type: "bar",
            height: 350,
            stacked: false,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
            },
          },
          xaxis: {
            categories: uniqueArray,
          },
          legend: {
            position: "right",
            offsetY: 40,
          },
          fill: {
            opacity: 1,
          },
        };

        var chart = new ApexCharts(
          document.querySelector("#graficomeses1"),
          options
        );
        chart.render();
      });
    },
    vergraficosservicios() {
      const peticion = {
        fechainicial: this.fechainicial,
        fechafinal: this.fechafinal,
        accion: "S",
      };
      axios.post("ver_graficos_servicios", peticion).then((response) => {
        var mes = [];
        var cantidad_consulta = [];
        let datos = response.data;
        for (const color of datos) {
          const sedeExistente = cantidad_consulta.find(
            (item) => item.name === color.nombre_servicio
          );
          if (sedeExistente) {
            sedeExistente.data.push(color.cantidad);
          } else {
            var datosgraficos = {
              name: color.nombre_servicio,
              data: [color.cantidad],
            };
            cantidad_consulta.push(datosgraficos);
          }
          mes.push(color.nombre_sede);
        }

        const uniqueArray = ["Servicios"];
        var options = {
          series: cantidad_consulta,
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                total: {
                  enabled: true,
                  offsetX: 0,
                  style: {
                    fontSize: "13px",
                    fontWeight: 900,
                  },
                },
              },
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          title: {
            text: "Total Turnos",
          },
          xaxis: {
            categories: uniqueArray,
            labels: {
              formatter: function (val) {
                return val + "T";
              },
            },
          },
          yaxis: {
            title: {
              text: undefined,
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + "T";
              },
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
          },
        };

        var chart = new ApexCharts(
          document.querySelector("#graficoservicio"),
          options
        );
        chart.render();
      });
    },
    vergraficos() {
      const peticion = {
        fechainicial: this.fechainicial,
        fechafinal: this.fechafinal,
        accion: "S",
      };
      axios.post("ver_graficos_servicios", peticion).then((response) => {
        var mes = [];
        var cantidad_consulta = [];
        console.log(response.data);
        let datos = response.data;
        for (const color of datos) {
          var datosgraficos = parseInt(color.cantidad);
          cantidad_consulta.push(datosgraficos);
          mes.push(color.nombre_servicio);
        }
        console.log(cantidad_consulta);
        var options = {
          series: cantidad_consulta,
          chart: {
            width: 480,
            type: "pie",
          },
          labels: mes,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        };
        var chart = new ApexCharts(document.querySelector("#grafico"), options);
        chart.render();
      });
    },
  },
};
</script>
<style scoped>
.coloriconos {
  color: white;
}
</style>
